module.exports = {
    props : ['slide', 'index'],
    template: require('./solution.html')
};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/solution/solution.js
// module id = 97
// module chunks = 0